// Brand assets and configuration
export const BRAND = {
  name: 'PC NERDS',
  tagline: 'BUY • BUILD • UPGRADE',
  logo: 'https://customer-assets.emergentagent.com/job_claude-check-7/artifacts/bbr2mpoo_WhatsApp%20Image%202026-06-18%20at%2012.03.32%20AM.jpeg',
  // Company info for documents
  company: {
    name: 'PC NERDS',
    tagline: 'BUY • BUILD • UPGRADE',
    address: '',
    phone: '',
    email: '',
    website: ''
  }
};
